import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { Strategy, strategyOptions } from 'src/api/types';
import { HintableOption, OptionWithHint } from 'src/components/form/Select/comps';
import { LABELS } from '../labels';

const optionsWithHints: HintableOption[] = strategyOptions.map((o) => {
  let hint = '';
  switch (o.value) {
    case Strategy.Transfer:
      hint = LABELS.controlStrategyTransfer;
      break;
    case Strategy.Treat:
      hint = LABELS.controlStrategyTreat;
      break;
    case Strategy.Tolerate:
      hint = LABELS.controlStrategyTolerate;
      break;
    case Strategy.Terminate:
      hint = LABELS.controlStrategyTerminate;
      break;
  }
  return {
    ...o,
    hint,
  };
});

interface StrategySelectProps extends Omit<Props, 'value'> {
  value: string | undefined | null;
  onChange: (value: { label: string; value: string }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
}

export const StrategySelect: React.FC<StrategySelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select strategy',
}) => {
  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={_.find(optionsWithHints, (o) => o.value === value)}
        placeholder={placeholder}
        options={optionsWithHints}
        onChange={onChange}
        onBlur={onBlur}
        inputId="strategy-select"
        components={{ Option: OptionWithHint }}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
